import Error from "next/error";
import DynamicTemplate from "components/templates/dynamic-template/dynamic-template";
import BaseTemplatePage from "./base-template-page";

export default class DynamicTemplatePage extends BaseTemplatePage {
  static async getInitialProps({ req, res, asPath }) {
    const superInitialProps = await BaseTemplatePage.getInitialProps({ req, res, asPath });
    return superInitialProps;
  }

  render() {
    const { errorCode } = this.props;
    if (errorCode) return <Error statusCode={errorCode} />;

    return <DynamicTemplate {...this.props} />;
  }
}
